/**
 * Vue Router routes для модуля Backup
 * Доступ только для admin@admin.ru (проверка на бэке через BackupAccess middleware)
 */

import { useAuthStore } from '@/stores/auth.js'

function backupAccessGuard(to, from, next) {
  const authStore = useAuthStore()
  const email = authStore.currentUser?.email
  const allowed = ['admin@admin.ru']
  if (email && allowed.includes(email)) {
    next()
  } else {
    next({ name: 'Home' })
  }
}

export const backupRoutes = {
  path: '/admin/backup',
  component: () => import('@/layouts/Authenticated.vue'),
  meta: {
    requiresAuth: true,
    title: 'Резервные копии',
  },
  beforeEnter: backupAccessGuard,
  children: [
    {
      path: '',
      name: 'BackupIndex',
      component: () => import('./pages/BackupIndex.vue'),
    },
  ],
};
